import React from 'react'
import { WaitingView } from '../components/page/waiting_view'

const Gamepad = () => {
  return <WaitingView />
}


export default Gamepad
